"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlSharingType = exports.SpreadsheetSharingFrom = exports.ContainerMethod = exports.InvokeMethod = void 0;
/**
 * JS SDK 之间通信用的方法。一般用在 ShimoBroadcastChannel.invoke() 中。
 */
var InvokeMethod;
(function (InvokeMethod) {
    /**
     * SDK 初始化，用于获取配置信息
     */
    InvokeMethod["SDKInit"] = "SDKInit";
    /**
     * 用于 error 处理
     */
    InvokeMethod["Error"] = "error";
    /**
     * 用于处理 ReadyState 变化
     */
    InvokeMethod["ReadyState"] = "readyState";
    /**
     * 用于更新鉴权信息
     */
    InvokeMethod["SetCredentials"] = "setCredentials";
    /**
     * 调用容器方法
     */
    InvokeMethod["InvokeContainerMethod"] = "invokeContainerMethod";
    /**
     * 请求调用编辑器方法，并将结果返回
     */
    InvokeMethod["InvokeEditorMethod"] = "invokeEditorMethod";
    /**
     * 派发 SDK 自身相关的事件
     */
    InvokeMethod["DispatchSDKEvent"] = "dispatchSDKEvent";
    /**
     * 派发编辑器相关的事件
     */
    InvokeMethod["DispatchEditorEvent"] = "dispatchEditorEvent";
    /**
     * 监听编辑器相关的事件
     */
    InvokeMethod["ListenEditorEvent"] = "listenEditorEvent";
    /**
     * 请求性能信息列表
     */
    InvokeMethod["RequestPerformanceEntries"] = "requestPerformanceEntries";
})(InvokeMethod = exports.InvokeMethod || (exports.InvokeMethod = {}));
/**
 * 容器能提供的方法
 */
var ContainerMethod;
(function (ContainerMethod) {
    /**
     * 获取容器的尺寸信息
     */
    ContainerMethod["GetContainerRect"] = "getContainerRect";
    /**
     * 请求容器打开链接
     */
    ContainerMethod["OpenLink"] = "openLink";
    /**
     * 请求容器生成 URL
     */
    ContainerMethod["GenerateUrl"] = "generateUrl";
    /**
     * 请求容器打开处理移动端点击事件
     */
    ContainerMethod["MentionClickHandlerForMobile"] = "mentionClickHandlerForMobile";
    /**
     * 请求容器解析 URL，并返回 FileInfo
     */
    ContainerMethod["GetFileInfoFromUrl"] = "getFileInfoFromUrl";
    /**
     * 请求容器显示签名组件，受套件和版本限制
     */
    ContainerMethod["ShowSignatureComponent"] = "showSignatureComponent";
    /**
     * 请求容器显示toast，受套件和版本限制
     */
    ContainerMethod["ShowToast"] = "showToast";
    /**
     * 通知用户执行自定义操作，操作由用户自定义按钮触发
     */
    ContainerMethod["HandleCustomTask"] = "handleCustomTask";
    /**
     * 请求容器获取鉴权信息
     */
    ContainerMethod["GetCredentials"] = "getCredentials";
})(ContainerMethod = exports.ContainerMethod || (exports.ContainerMethod = {}));
var SpreadsheetSharingFrom;
(function (SpreadsheetSharingFrom) {
    /**
     * 获取选区链接
     */
    SpreadsheetSharingFrom["copyRangeLink"] = "copyRangeLink";
    /**
     * 复制独立视图链接
     */
    SpreadsheetSharingFrom["copyViewportLink"] = "copyViewportLink";
    /**
     * 复制链接到工作表的内链接
     */
    SpreadsheetSharingFrom["copySheetLink"] = "copySheetLink";
    /**
     * 跨表格引用
     */
    SpreadsheetSharingFrom["importRange"] = "importRange";
    /**
     * 预览被跨表引用或合并工作表引用的表格
     */
    SpreadsheetSharingFrom["preview"] = "preview";
})(SpreadsheetSharingFrom = exports.SpreadsheetSharingFrom || (exports.SpreadsheetSharingFrom = {}));
/**
 * 分享链接的类型，用于在 generateUrl 中返回不同的 URL。
 * 比如 return sharingType === UrlSharingType.FormFill ? '/form/1/fill' : '/form/1'。
 * '/form/1/fill' 为对外匿名可访问填写表单的链接，'/form/1' 为对内编辑表单元素、需鉴权的链接。
 */
var UrlSharingType;
(function (UrlSharingType) {
    /**
     * 代表分享的是轻文档链接
     */
    UrlSharingType["Doc"] = "doc";
    /**
     * 代表分享的是传统文档链接
     */
    UrlSharingType["Docx"] = "docx";
    /**
     * 代表分享的是表格链接
     */
    UrlSharingType["Spreadsheet"] = "sheet";
    /**
     * 代表分享的是表单编辑器链接
     */
    UrlSharingType["Form"] = "form";
    /**
     * 代表分享的是表单预览链接
     */
    UrlSharingType["FormPreview"] = "formPreview";
    /**
     * 代表分享的是表单填写链接
     */
    UrlSharingType["FormFill"] = "formFill";
    /**
     * 代表分享的是幻灯片链接
     */
    UrlSharingType["Presentation"] = "presentation";
    /**
     * 代表分享的是应用表格链接
     */
    UrlSharingType["Table"] = "table";
    /**
     * 代表分享的是流程图链接
     */
    UrlSharingType["Flowchart"] = "flowchart";
    /**
     * 代表分享的是思维导图链接
     */
    UrlSharingType["Mindmap"] = "mindmap";
    /**
     * 代表分享的是白板链接
     */
    UrlSharingType["Board"] = "board";
})(UrlSharingType = exports.UrlSharingType || (exports.UrlSharingType = {}));
